import { action } from "@ember/object"
import { oneWay } from "@ember/object/computed"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import { tracked } from "@glimmer/tracking"
import type SchoolYear from "@shared/models/school-year"
import { task } from "ember-concurrency"
import { includes, map } from "lodash-es"

export default class AdminSchoolYearIndex extends Component {
  @service("ember-store") store
  @service rpc
  @service session
  @service router

  @oneWay("fetchRecords.isRunning") isLoading

  get columns() {
    return [
      {
        name: "ID",
        valuePath: "id",
        width: 200,
      },
      {
        name: "Title",
        valuePath: "attributes.title",
        width: 200,
      },
      {
        name: "Is Off",
        valuePath: "attributes.isOff",
        width: 25,
      },
      {
        name: "Start Date",
        valuePath: "attributes.startDate",
      },
      {
        name: "End Date",
        valuePath: "attributes.endDate",
      },
      {
        id: "schoolYearIds",
        name: "School Years",
        valuePath: "relationships.schoolYears.data",
      },
    ]
  }

  // TODO Add type
  @tracked model: Array<any> = []
  @tracked schoolYears: Array<SchoolYear> = []
  @tracked enableSync = true

  fetchRecords = task({ keepLatest: true }, async () => {
    let records = await this.rpc.ADMIN_HOLIDAY_INDEX()
    this.model = records.data
  })

  fetchSchoolYears = task({ keepLatest: true }, async () => {
    let records = await this.rpc.ADMIN_SCHOOL_YEAR_INDEX()
    this.schoolYears = records.data
  })

  @action async onRowClick(row) {
    let { results: holidays } = await this.rpc.holidays_for_school_year({
      schoolYearId: "SY20192020",
    })

    this.router.transitionTo("admin.holidays.index")
  }

  @action hasSchoolYearId(id, schoolYearRelationships) {
    let schoolYearIds = map(schoolYearRelationships, (datum) => datum.id)
    return includes(schoolYearIds, id)
  }
}
